import * as React from "react";

import { ContentRoutes, useContentRoute } from "./providers";

import { Banner } from "./banner";
import { AppLoading } from "./app-loading";
import { PageDetails } from "./page-details";
import { PageSuccess } from "./page-success";

export const Page: React.FunctionComponent = () => {
  const { selectedContentRoute } = useContentRoute();

  return (
    <section className="bbnt-forgot-password-page">
      <AppLoading />
      <Banner />
      <div className="content">
        {selectedContentRoute === ContentRoutes.Details && <PageDetails />}
        {selectedContentRoute === ContentRoutes.Success && <PageSuccess />}
      </div>
    </section>
  );
};
